import React from 'react';
import { MountainIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
export function GoalCard() {
  const {
    family
  } = useAppState();
  const g = family.goal;
  if (!g) return null;
  const pct = Math.min(100, Math.round(g.current / g.target * 100));
  return <section aria-labelledby="family-goal" className="rounded-3xl border-[1.5px] border-line bg-surface p-5" data-id="element-303" data-mp="3v2zjpm07y80u">
      <h2 id="family-goal" className="flex items-center gap-2 font-display text-lg font-semibold" data-id="element-304" data-mp="3vddblm47rga">
        <MountainIcon className="h-5 w-5 text-info" aria-hidden="true" data-id="element-305" data-mp="7wyl4sjslfjm" /> Skupni cilj: {g.title}
      </h2>
      <p className="mt-1 text-sm text-muted" data-id="element-306" data-mp="cq1dwygqwkyr">{g.reward}</p>
      <div className="mt-3 h-3 overflow-hidden rounded-full bg-line" aria-hidden="true" data-id="element-307" data-mp="hnjpkwm5deag">
        <div className="h-full rounded-full bg-info" style={{
        width: `${pct}%`
      }} data-id="element-308" data-mp="mmwero0hqxg7" />
      </div>
      <p className="mt-1.5 text-sm font-bold tabular-nums" data-id="element-309" data-mp="rm0kg4o7id1s">
        {g.current} / {g.target} skupnih točk · {pct} %
      </p>
      <p className="mt-1 text-xs text-muted" data-id="element-310" data-mp="31fcib2ruzpyj">Skupaj zbiramo z dodatnim trudom vseh. Lastni napredek ostane ločen.</p>
    </section>;
}